import { render } from "./TableRevisao.vue?vue&type=template&id=73cdc2d8&scoped=true"
import script from "./TableRevisao.vue?vue&type=script&lang=js"
export * from "./TableRevisao.vue?vue&type=script&lang=js"

import "./TableRevisao.vue?vue&type=style&index=0&id=73cdc2d8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cdc2d8"]])

export default __exports__